export const OptinTypes = {
  NEWSLETTER: 'optin_newsletter',
  SMS: 'optin_sms',
  MAIL: 'optin_mail'
} as const;
